import React from "react";
import TopBar from "../dashboard/TopBar";

const SalesNavBar = ({ toggleSidebar }) => (
  <TopBar toggleSidebar={toggleSidebar} />
);

export default SalesNavBar;
